import React, { ReactNode } from 'react';
import { useAuth } from '@/app/providers/AuthProvider';
import { usePlanModal } from '@/app/contexts/PlanModalContext';

interface RestrictedFeatureProps {
  permission: string;
  children: ReactNode;
  className?: string;
  as?: 'div' | 'span';
}

export function RestrictedFeature({ permission, children, className = '', as = 'div' }: RestrictedFeatureProps) {
  const { has } = useAuth();
  const { openModal } = usePlanModal();

  // Check if user has permission
  const isAllowed = has({ permission });

  if (isAllowed) {
    return <>{children}</>;
  }

  const Tag = as;

  return (
    <Tag 
      className={`relative cursor-pointer group ${className}`}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      }}
      role="button"
      aria-label="Locked feature, click to upgrade"
    >
      {/* We wrap children to apply styles, but we need to ensure layout is preserved. 
          Using flex to align the crown icon next to the content if possible. */}
      <div className="opacity-60 pointer-events-none grayscale flex items-center justify-center gap-1.5 w-full h-full">
         {children}
         <span className="text-base select-none shrink-0 filter drop-shadow-sm" role="img" aria-label="premium">👑</span>
      </div>
      
      {/* Overlay to capture clicks effectively */}
      <div className="absolute inset-0 z-20" />
    </Tag>
  );
}
